module.exports = __webpack_public_path__ + "static/media/book-disabled.c91fcf18.svg";